import { render, staticRenderFns } from "./CNCContainerPanel.vue?vue&type=template&id=0126b582&scoped=true"
import script from "./CNCContainerPanel.vue?vue&type=script&lang=ts"
export * from "./CNCContainerPanel.vue?vue&type=script&lang=ts"
import style0 from "./CNCContainerPanel.vue?vue&type=style&index=0&id=0126b582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0126b582",
  null
  
)

export default component.exports